import * as ce from "./custom_errors";
import { LlmModelDetailed, Workflow, LLMPlaybook, defaultModel } from "./rest_utils";
import { translate } from "../locales/i18n";
import { TaskCategory } from "../utils/task_utils";
// import { trafficLightWorkflows } from "../utils/common";

export function getFilteredWorkflowsCheck(workflows: Workflow[]): Workflow[] {
  return workflows
    .filter(
      (workflow: Workflow) =>
        workflow.parameterTypes.includes("word") && workflow.parameterTypes.includes("check")
    )
    .map((p) => ({
      ...p,
      title: p.title
        .replace(/(\[word\]|\(word\))/gi, "")
        .replace(/\s+/g, " ")
        .trim(),
    }));
}

export function getFilteredWorkflowsWord(workflows: Workflow[]): Workflow[] {
  // && !workflow.parameterTypes.includes("check")
  return workflows
    .filter((workflow: Workflow) => workflow.parameterTypes.includes("word"))
    .map((p) => ({
      ...p,
      title: p.title
        .replace(/(\[word\]|\(word\))/gi, "")
        .replace(/\s+/g, " ")
        .trim(),
    }));
}

export async function populateModelSelection(
  models: Promise<LlmModelDetailed[]>,
  selectElement: HTMLSelectElement,
  taskCategoryName: string
): Promise<void> {
  try {
    console.log("Loading available LLM models");
    const allLlmModels = await models;

    let firstNonDisabledModelIndex = 0;

    selectElement.innerHTML = "";
    selectElement.classList.remove("loading");

    allLlmModels
      .sort((a: LlmModelDetailed, b: LlmModelDetailed) => a.label.localeCompare(b.label))
      .forEach((llmModel: LlmModelDetailed) => {
        const option = new Option(llmModel.label, llmModel.name);
        option.title = llmModel.label;
        selectElement.appendChild(option);
      });

    const currentLlmModelIndex = await Word.run(async (context) => {
      const propLlmModelIndex = context.document.properties.customProperties.getItemOrNullObject(
        `current_llm_model_index_${taskCategoryName}`
      );
      await context.sync();
      if (!propLlmModelIndex.isNullObject) {
        propLlmModelIndex.load("value");
        await context.sync();
        return propLlmModelIndex.value;
      }
      const defaultSelectModelIndex = Array.from(selectElement.options).findIndex(
        (option: HTMLOptionElement) => option.value === defaultModel
      );
      return defaultSelectModelIndex ?? firstNonDisabledModelIndex;
    });
    selectElement.selectedIndex = currentLlmModelIndex;
  } catch (error) {
    console.error(error);
    throw new ce.LlmModelLoadError(translate("error-llm-loading"));
  }
}

// maybe replace display name in the future -> "Zusammenfassung | detailliert"
const workflowTitleAliases: { [key: string]: string } = {
  "detaillierte zusammenfassung": "zusammenfassung1",
};
export async function populateWorkflowSelection(
  workflows: Workflow[],
  selectElement: HTMLSelectElement,
  taskCategory: TaskCategory,
  taskCategoryName: string
): Promise<void> {
  try {
    let filteredWorkflows: Workflow[] = [];
    switch (taskCategory) {
      case "traffic-light":
        filteredWorkflows = getFilteredWorkflowsCheck(workflows);
        break;
        x;
      case "workflow":
        filteredWorkflows = getFilteredWorkflowsWord(workflows);
        break;
      default:
        filteredWorkflows = workflows;
    }

    selectElement.innerHTML = "";
    selectElement.classList.remove("loading");

    filteredWorkflows
      .sort((a: Workflow, b: Workflow) => {
        let aTitle = a.title.toLowerCase();
        aTitle = workflowTitleAliases[aTitle] ?? aTitle;
        let bTitle = b.title.toLowerCase();
        bTitle = workflowTitleAliases[bTitle] ?? bTitle;
        return aTitle.localeCompare(bTitle);
      })
      .forEach((workflow: Workflow) => {
        const option = new Option(workflow.title, workflow.id);
        option.title = workflow.title;
        selectElement.appendChild(option);
      });
  } catch (error) {
    console.error(error);
    throw new ce.WorkflowLoadError(translate("error-workflow-loading"));
  }
}

export async function populatePlaybookSelection(
  playbooks: Promise<LLMPlaybook[]>,
  selectElement: HTMLSelectElement,
  taskCategoryName: string
): Promise<void> {
  try {
    console.log("Loading available Playbooks");
    const playbookArray = await playbooks;

    selectElement.innerHTML = "";
    selectElement.classList.remove("loading");

    playbookArray
      .sort((a: LLMPlaybook, b: LLMPlaybook) => {
        return a.title.localeCompare(b.title);
      })
      .forEach((playbook: LLMPlaybook) => {
        const option = new Option(playbook.title, playbook.id);
        option.title = playbook.title;
        selectElement.appendChild(option);
      });
    selectElement.selectedIndex = -1;
  } catch (error) {
    console.error(error);
    throw new ce.PlaybookLoadError(translate("error-playbook-loading"));
  }
}

export function populatePlaybookCategorySelection(
  playbookCategories: string[],
  selectElement: HTMLSelectElement
): void {
  try {
    // playbookCategories.sort();
    playbookCategories.forEach((category: string) => {
      const option = new Option(category, category);
      option.title = category;
      selectElement.appendChild(option);
    });
    const optionAll = new Option("Alle", "all");
    optionAll.title = "Alle Kategorien";
    selectElement.prepend(optionAll);
  } catch (error) {
    console.error(error);
    throw new ce.PlaybookDocumentContentError(translate("error-playbook-category-loading"));
  }
}
